import "@fontsource/dm-sans/400.css";
import "@fontsource/dm-sans/600.css";
import "@fontsource/dm-sans/700.css";
import "./src/styles/global.css";
import { initAnalytics, trackPageView } from "./src/utils/analytics";

export const onClientEntry = () => {
  initAnalytics();
};

export const onRouteUpdate = ({ location }) => {
  trackPageView(location.pathname);
};
